@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-detail-section>
            <ui-detail-image
                [imagePath]="mapItem.imagePath"
                [altText]="mapItem.title"
            />
            <ui-detail-title [title]="mapItem.title"/>
            <ui-detail-address [text]="mapItem.address"/>
            <ui-detail-tags
                [tags]="[mapItem.categoryLabel]"
            />
        </ui-detail-section>
        @if (mapItem.description || mapItem.shortDescription) {
            <ui-detail-description
                [htmlDescription]="mapItem.description || mapItem.shortDescription"
            />
        }
        @if (mapItem.industries.length) {
            <ui-detail-tags
                [title]="'Branchen'"
                [tags]="mapItem.industries"
            />
        }
        @if (mapItem.closestPublicTransport) {
            <ui-detail-weblink
                [title]="'Nächste AVV-Haltestelle'"
                [link]="mapItem.closestPublicTransport.link"
                [linkLabel]="mapItem.closestPublicTransport.name"
            />
        }
        @if (mapItem.weblink) {
            <ui-detail-weblink
                [title]="'Weitere Infos'"
                [link]="mapItem.weblink"
            />
        }
    </ui-detail-view-container>
}
